import { QueryKey } from 'react-query';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('ReactQuery');

export const invalidateQueries = actionCreator<QueryKey>('invalidateQueries');
